module.exports = __webpack_public_path__ + "static/media/mic_on.4b8eedd3.svg";